/* Carry explicit campaign tags through the shopping journey and quote forms.
   No cookies, persistent storage, fingerprinting or network requests. */
(() => {
  'use strict';
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  const params = new URLSearchParams(window.location.search);
  const tags = keys.map(key => [key, params.get(key)])
    .filter(([, value]) => value && /^[a-zA-Z0-9_-]{1,80}$/.test(value));
  if (!tags.length) return;
  const apply = () => {
    document.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      let url;
      try { url = new URL(href, window.location.href); } catch { return; }
      if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages|products|collections|blogs)\//i.test(url.pathname)) return;
      tags.forEach(([key, value]) => { if (!url.searchParams.has(key)) url.searchParams.set(key, value); });
      link.href = url.pathname + url.search + url.hash;
    });
    document.querySelectorAll('form').forEach(form => {
      const type = form.querySelector('input[name="form_type"]');
      if (!type || type.value !== 'contact') return;
      tags.forEach(([key, value]) => {
        const name = `contact[${key}]`;
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = value;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
})();
